



























































































import { Component, Vue } from 'vue-property-decorator';
import UpdateProofOfAddressAttachYourDocumentViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-proof-of-address/update-proof-of-address-attach-your-document-view-model';

@Component({ name: 'UpdateProofOfAddressAttachYourDocument' })
export default class UpdateProofOfAddressAttachYourDocument extends Vue {
  update_address_attach_view_model = Vue.observable(
    new UpdateProofOfAddressAttachYourDocumentViewModel(this),
  );

  async mounted() {
    await this.update_address_attach_view_model.initialize();
  }
}
